import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { mergeMap, Observable } from "rxjs";
import { MsalService } from "@azure/msal-angular";
import { environment } from "../../../environments/environment";

@Injectable()
export class TokenInterceptor implements HttpInterceptor, OnInit {
  constructor(private authService: MsalService) {}

  ngOnInit(): void {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.has("Authorization")) {
      return next.handle(request);
    }

    if (request.url.indexOf(environment.msGraphUrl) > -1) {
      return this.addAuthHeaderForGraph(request, next);
    } else if (request.url.indexOf(environment.apiUrl) > -1) {
      return this.addAuthHeaderForApi(request, next);
    } else if (request.url.indexOf(environment.athenaApiUrl) > -1) {
      return this.addAuthHeaderForSearch(request, next);
    }

    return next.handle(request);
  }

  private addAuthHeaderForGraph(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const loginRequest = {
      scopes: environment.msalConfig.graphScopes,
    };
    return this.authService.acquireTokenSilent(loginRequest).pipe(
      mergeMap((token) => {
        return next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${token.accessToken}`,
            },
          })
        );
      })
    );
  }

  private addAuthHeaderForApi(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const loginRequest = {
      scopes: [`${environment.appRegistration.clientId}/user_impersonation`],
    };
    return this.authService.acquireTokenSilent(loginRequest).pipe(
      mergeMap((token) => {
        return next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${token.accessToken}`,
            },
          })
        );
      })
    );
  }

  private addAuthHeaderForSearch(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const loginRequest = {
      scopes: [...environment.msalConfig.athenaSearchScope],
    };
    return this.authService.acquireTokenSilent(loginRequest).pipe(
      mergeMap((token) => {
        return next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${token.accessToken}`,
            },
          })
        );
      })
    );
  }
}
